import React, { useEffect, useState, useRef } from 'react';
import styled from "styled-components";
import { useLanguage } from "./LanguageContext";

// Predefined Colors for Known Aromas
const aromaColors = {
  animalic: "linear-gradient(to right, #705D3E, #4A3822)",
  ცხოველური: "linear-gradient(to right, #705D3E, #4A3822)",
  woody: "linear-gradient(to right, #9C6644, #6D4C41)",
  ხის: "linear-gradient(to right, #9C6644, #6D4C41)",
  citrus: "linear-gradient(to right, #FFDE59, #FFA500)",
  ციტრუსის: "linear-gradient(to right, #FFDE59, #FFA500)",
  ციტრუსი: "linear-gradient(to right, #FFDE59, #FFA500)",
  floral: "linear-gradient(to right, #FF69B4, #FFB6C1)",
  ყვავილოვანი: "linear-gradient(to right, #FF69B4, #FFB6C1)",
  mossy: "linear-gradient(to right, #6A8D73, #507C5C)",
  ხავსიანი: "linear-gradient(to right, #6A8D73, #507C5C)",
  oriental: "linear-gradient(to right, #D2691E, #A0522D)",
  აღმოსავლური: "linear-gradient(to right, #D2691E, #A0522D)",
  fruity: "linear-gradient(to right, #FF6347, #FF4500)",
  ხილის: "linear-gradient(to right, #FF6347, #FF4500)",
  fresh: "linear-gradient(to right, #00CED1, #20B2AA)",
  ახალი: "linear-gradient(to right, #00CED1, #20B2AA)",
  "fresh spicy": "linear-gradient(to right, #00CED1, #20B2AA)",
  "ახალი სუნელი": "linear-gradient(to right, #00CED1, #20B2AA)",
  spicy: "linear-gradient(to right, #FF4500, #D2691E)",
  ცხარე: "linear-gradient(to right, #FF4500, #D2691E)",
  earthy: "linear-gradient(to right, #806040, #5D4037)",
  მიწიერი: "linear-gradient(to right, #806040, #5D4037)",
  მიწის: "linear-gradient(to right, #806040, #5D4037)",
  sweet: "linear-gradient(to right, #F48FB1, #EC407A)",
  ტკბილი: "linear-gradient(to right, #F48FB1, #EC407A)",
  tropical: "linear-gradient(to right, #FFD700, #FFA500)",
  ტროპიკული: "linear-gradient(to right, #FFD700, #FFA500)",
  patchouli: "linear-gradient(to right, #75534E, #5C4033)",
  პაჩული: "linear-gradient(to right, #75534E, #5C4033)",
  aromatic: "linear-gradient(to right, #91A65B, #748C47)",
  არომატული: "linear-gradient(to right, #91A65B, #748C47)",
  aquatic: "linear-gradient(to right, #4682B4, #5F9EA0)",
  წყლის: "linear-gradient(to right, #4682B4, #5F9EA0)",
  leather: "linear-gradient(to right, #8B4513, #A0522D)",
  ტყავის: "linear-gradient(to right, #8B4513, #A0522D)",
  musk: "linear-gradient(to right, #D3D3D3, #B0C4DE)",
  მუშკი: "linear-gradient(to right, #D3D3D3, #B0C4DE)",
  "warm spicy": "linear-gradient(to right, #D2691E, #A0522D)",
  "თბილი სუნელი": "linear-gradient(to right, #D2691E, #A0522D)",
  chocolate: "linear-gradient(to right, #8B4513, #A0522D)",
  შოკოლადი: "linear-gradient(to right, #8B4513, #A0522D)",
  cacao: "linear-gradient(to right, #5D4037, #4E342E)",
  კაკაო: "linear-gradient(to right, #5D4037, #4E342E)",
  musky: "linear-gradient(to right, #D3D3D3, #B0C4DE)",
  მუშკის: "linear-gradient(to right, #D3D3D3, #B0C4DE)",
  მუშკი: "linear-gradient(to right, #D3D3D3, #B0C4DE)",
  amber: "linear-gradient(to right, #FFBF00, #D69E2E)",
  ქარვის: "linear-gradient(to right, #FFBF00, #D69E2E)",
  smoky: "linear-gradient(to right, #4E4E50, #2C2C2C)",
  თამბაქოს: "linear-gradient(to right, #4E4E50, #2C2C2C)",
  ბოლქვიანი: "linear-gradient(to right, #4E4E50, #2C2C2C)",
  balsamic: "linear-gradient(to right, #A67B5B, #8E6342)",
  ბალზამური: "linear-gradient(to right, #A67B5B, #8E6342)",
  marine: "linear-gradient(to right, #4682B4, #5F9EA0)",
  საზღვაო: "linear-gradient(to right, #4682B4, #5F9EA0)",
  aquatic: "linear-gradient(to right, #5F9EA0, #20B2AA)",
  წყლის: "linear-gradient(to right, #5F9EA0, #20B2AA)",
  ქარვა: "linear-gradient(to right, #FFBF00, #D2691E)",
  powdery: "linear-gradient(to right, #E6C2BF, #F5E1DA)",
  პუდროვანი: "linear-gradient(to right, #E6C2BF, #F5E1DA)",
  ozonic: "linear-gradient(to right, #B0E0E6, #87CEEB)",
  ოზონური: "linear-gradient(to right, #B0E0E6, #87CEEB)",
  oud: "linear-gradient(to right, #8B4513, #654321)",
  უდი: "linear-gradient(to right, #8B4513, #654321)",
  coffee: "linear-gradient(to right, #6F4E37, #4B382A)",
  ყავა: "linear-gradient(to right, #6F4E37, #4B382A)",
  rose: "linear-gradient(to right, #FF007F, #FF69B4)",
  ვარდი: "linear-gradient(to right, #FF007F, #FF69B4)",
  ამბრა: "linear-gradient(to right, #FFBF00, #E6A300)",
  vanilla: "linear-gradient(to right, #F3E5AB, #E6C3A9)",  // ✅ Vanilla added
  ვანილი: "linear-gradient(to right, #F3E5AB, #E6C3A9)",  // ✅ ვანილი added
  ვანილის: "linear-gradient(to right, #F3E5AB, #E6C3A9)",  // ✅ ვანილი added
  metallic: "linear-gradient(to right, #B0C4DE, #A9A9A9)",  // ✅ New entry
  მეტალური: "linear-gradient(to right, #B0C4DE, #A9A9A9)",  // ✅ New entry
  lavender: "linear-gradient(to right, #B57EDC, #9370DB)",  // ✅ New entry
  ლავანდა: "linear-gradient(to right, #B57EDC, #9370DB)",  // ✅ New entry
  green : "linear-gradient(to right, #66CDAA, #228B22)",
  მწვანე: "linear-gradient(to right, #66CDAA, #228B22)",
};

// Generate a unique color for unknown aromas
const getRandomColor = (aroma) => {
  const hash = [...aroma].reduce((acc, char) => acc + char.charCodeAt(0), 0);
  const hue = hash % 360; // Rotate hue based on hash
  return `hsl(${hue}, 70%, 50%)`; // Ensure brightness and uniqueness
};

// Get aroma color (use predefined or generate dynamically)
const getAromaColor = (aroma) => {
  return aromaColors[aroma] || getRandomColor(aroma);
};

const AromaContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 10px;
  max-width: 300px;
  padding-right: 20px;
  max-height: ${({ isOpen }) => (isOpen ? "500px" : "0px")};
  overflow: hidden;
  transition: max-height 0.4s ease-in-out;
`;

const AromaBadge = styled.span`
  display: block;
  font-size: 14px;
  font-weight: bold;
  color: white;
  text-transform: capitalize;
  padding: 5px 12px;
  border-radius: 5px;
  background: ${({ aroma }) => getAromaColor(aroma)};
  width: ${({ width }) => width}px;
  transition: width 0.5s ease-in-out;
`;

const ToggleSection = styled.div`
  margin-top: 1rem;
  cursor: pointer;
  padding: 0.5rem;
  background: #f9f9f9;
  border-radius: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  max-width: 270px;
`;

const AromaSection = ({ perfume }) => {
  const { t } = useLanguage();
  const aromaKey = t("detailtranslate.aroma");
  const aromaTypes = perfume[aromaKey]?.split(",").map((a) => a.trim().toLowerCase()) || [];
  const [isAromaOpen, setisAromaOpen] = useState(false);
  const aromaRef = useRef(null);

  const handleToggle = () => {
    setisAromaOpen((prev) => !prev);
  };

  return (
    <div>
      <ToggleSection onClick={handleToggle} ref={aromaRef}>
        <span><strong>{t("detailed.aroma")}</strong></span>
        <span>{isAromaOpen ? "−" : "+"}</span>
      </ToggleSection>
      <AromaContainer isOpen={isAromaOpen}>
        {aromaTypes.map((aroma, index) => {
          const maxWidth = 250; // Max width for first note
          const fillWidth = maxWidth * Math.pow(0.9, index); // Reduce width by 10% each step

          return <AromaBadge key={aroma} aroma={aroma} width={fillWidth}>{aroma}</AromaBadge>;
        })}
      </AromaContainer>
    </div>
  );
};

export default AromaSection;
